import PropTypes from "prop-types";
import ResultsHeader from "./ResultsHeader";
import ResultsFooter from "./ResultsFooter";
import styles from "./ProductList.css";
import { withTranslation } from "../translation";
import withAdverts from "./withAdverts";
import ListBody from "./ListBody";

const ResultsList = ({
  pages,
  offset,
  tileToFocus,
  itemCount,
  showLoadPrevious,
  showLoadMore,
  isLoading,
  listAdvert,
  footerAdvert,
  faceAndBodyCarousel
}) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <ResultsHeader
        showLoadPrevious={showLoadPrevious}
        itemCount={itemCount}
      />
      <ListBody
        isLoading={isLoading}
        pages={pages}
        tileToFocus={tileToFocus}
        offset={offset}
        advert={listAdvert}
        faceAndBodyCarousel={faceAndBodyCarousel}
      />
      <ResultsFooter
        hasPages={!!pages.length}
        itemCount={itemCount}
        offset={offset}
        showLoadMore={showLoadMore}
      />
      {footerAdvert ? footerAdvert({ className: styles.advert }) : null}
    </div>
  </div>
);

ResultsList.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.object).isRequired,
  offset: PropTypes.object.isRequired,
  tileToFocus: PropTypes.shape({
    first: PropTypes.bool,
    last: PropTypes.bool,
    pageNumber: PropTypes.number
  }).isRequired,
  itemCount: PropTypes.number.isRequired,
  showLoadPrevious: PropTypes.bool.isRequired,
  showLoadMore: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  listAdvert: PropTypes.func,
  footerAdvert: PropTypes.func,
  formatTranslation: PropTypes.func.isRequired,
  faceAndBodyCarousel: PropTypes.func
};

export default withAdverts(withTranslation(ResultsList));
